import {Component, OnInit, TemplateRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {CrudComponent} from '../../../../shared/components/crud/crud.component';
import {BaseResponse} from '../../../../shared/models/respose/BaseResponse';
import {PaginatedDataResponse} from '../../../../shared/models/respose/PaginatedDataResponse';
import {Task} from '../../../../shared/models/Task';
import {TaskService} from '../../../services/task.service';
import {Order} from '../../../../shared/models/Order';
import {DirectionType} from '../../../enum/DirectionType';
import {Pagination} from '../../../../shared/models/Pagination';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.css']
})
export class TasksComponent extends CrudComponent {
  public paginatedResponse: PaginatedDataResponse<Task> = new PaginatedDataResponse<Task>(0, [], 0, 0, 0);

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private service: TaskService
  ) {
    super(modalService, fb);
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    this.order = new Order('name', DirectionType.asc);
    this.form = this.fb.group({
      id: [null],
      name: ['', [Validators.required]]
    });
    this.formSearch = this.fb.group({
      name: ['']
    });
    this.updateList({page: 1, elements: this.elements});
  }

  onSubmit({value, valid}: { value: Task, valid: boolean }): void {
    if (valid) {
      if (value.id) {
        this.callUpdate(value);
      } else {
        this.callRegister(value);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  onFind({value, valid}: { value: any, valid: boolean }): void {
    this.updateList({page: 1, elements: this.elements});
  }

  updateList(pagination: Pagination = {page: 1, elements: this.elements}): void{
    const task: Task = this.formSearch.value;
    this.service.getPaginatedList(pagination.elements, pagination.page, task, this.order).subscribe(
      (response: BaseResponse<PaginatedDataResponse<Task>>) => {
        this.paginatedResponse = response.data;
      }
    );
  }

  openTrashModal(content: TemplateRef<any>, task: Task): void {
    this.modalService.open(content, {ariaLabelledBy: 'appointment-detail-modal-basic-title'}).result.then((result) => {
      this.service.deleteItem(task.id).subscribe(() => this.updateList({page: 1, elements: this.elements}));
    }, (reason) => {
    });
  }

  edit(task: Task): void {
    this.form.setValue(
      {
        id: task.id,
        name: task.name
      }
    );
    this.showHideForm();
  }

  callRegister(task: Task): void {
    this.service.register(task).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }

  callUpdate(task: Task): void {
    this.service.updateItem(task, task.id).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }
}
